import request from "@/utils/request";

// 获取数据
export function getData(data) {
    return request({
        url: "match/match/matchInformList",
        method: "post",
        data
    });
}

// 获取详情
export function getDataInfo(params) {
    return request({
        url: `/match/match/matchInformInfo/${params}`,
        method: "get",
    });
}


// WEBPACK FOOTER //
// ./src/api/notice.js